import {Checkbox, Form, Input} from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
const ProposalEmailOrSite = ({ id, value, onChange, label, extraLabel, placeholderText, translate, rules, ...rest }) => {
  const { t } = useTranslation(translate || 'common');
  let [checked, setChekhed] = useState(false);
  let [data, setData] = useState('');
  const [form] = Form.useForm();

  useEffect(() => {
    if (value) {
      setData(value || '');
      setChekhed(true);
    }
  }, [value]);

  const onActiveChange = useCallback((e) => {
    setChekhed(e?.target?.checked);
    if (!e?.target?.checked) {
      onChange && onChange(null);
      setData(null);
    }else{
      onChange && onChange(data);
    }
    form.resetFields();
  }, [form, onChange, data]);

  return (<>
    <Checkbox
      checked={checked}
      className={classNames('mx-0 my-px')}
      size={'large'}
      onChange={onActiveChange}
    >{t(label)}</Checkbox>
    {checked &&
          <Form.Item
            {...rest}
            size={'large'}
            label={t(extraLabel)} name={id} className="mb-0 mt-2"
            rules={[...rules, {required: checked}]}
            initialValue={data}
            required={checked}
          >
            <Input {...rest} placeholder={t(placeholderText)}/>
          </Form.Item>
    }
  </>);
};

ProposalEmailOrSite.propTypes = {
  id: PropTypes.string,
  value: PropTypes.object,
  fileLabel: PropTypes.string,
  extraLabel: PropTypes.string,
  placeholderText: PropTypes.string,
  rules: PropTypes.any,
  translate: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func
};

ProposalEmailOrSite.defaultProps = {};

export default memo(ProposalEmailOrSite);
